import { useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'

export default function Navbar() {
  const [open, setOpen] = useState(false)
  const navigate = useNavigate()
  const location = useLocation()

  const handleSectionClick = (e, href) => {
    e.preventDefault()
    e.stopPropagation()
    setOpen(false)
    const id = href.replace(/^#/, '')
    if (!id) return

    window.requestAnimationFrame(() => {
      navigate({ pathname: location.pathname, search: location.search, hash: id })
    })
  }

  return (
    <nav className="sticky top-0 z-50 relative backdrop-blur-md border-b border-neutral-100" style={{ background: 'rgba(250,250,248,0.96)' }}>
      <div className="flex items-center justify-between flex-wrap px-5 py-4 md:px-10 lg:px-16 md:flex-nowrap">
        <Link to="/" className="no-underline">
          <img src="/waitherelogo.png" alt="Waithere" className="h-7 w-auto" />
        </Link>

        {/* Hamburger */}
        <button
          className="flex flex-col justify-center gap-[5px] w-11 h-11 bg-transparent border-none cursor-pointer p-2 rounded-lg md:hidden"
          onClick={() => setOpen(!open)}
          aria-label="Abrir menu"
        >
          <span
            className={`block w-[22px] h-[2px] bg-black rounded-sm transition-transform duration-200 ${open ? 'translate-y-[7px] rotate-45' : ''}`}
          />
          <span
            className={`block w-[22px] h-[2px] bg-black rounded-sm transition-opacity duration-200 ${open ? 'opacity-0' : ''}`}
          />
          <span
            className={`block w-[22px] h-[2px] bg-black rounded-sm transition-transform duration-200 ${open ? '-translate-y-[7px] -rotate-45' : ''}`}
          />
        </button>

        {/* Nav Links */}
        <ul
          className={`
            ${open ? 'flex' : 'hidden'}
            md:flex flex-col md:flex-row
            gap-0 md:gap-8 lg:gap-9
            list-none w-full md:w-auto
            absolute md:relative left-0 right-0 top-full md:top-auto
            pt-3 pb-4 md:p-0 px-5 md:px-0
            border-b md:border-none border-neutral-100
            shadow-lg md:shadow-none
            items-stretch md:items-center
            backdrop-blur-md md:backdrop-blur-none
          `}
          style={{ background: 'rgba(250,250,248,0.98)' }}
        >
          {[
            { label: 'Cardápio', href: '#cardapio' },
            { label: 'Pedidos', href: '#pedidos' },
            { label: 'Mesas', href: '#mesas' },
            { label: 'Preços', href: '#precos' },
          ].map((item) => (
            <li key={item.label} className="w-full md:w-auto border-b md:border-none border-neutral-100 last:border-none">
              <a
                href={item.href}
                onClick={(e) => handleSectionClick(e, item.href)}
                className="block text-neutral-500 font-medium no-underline py-3 md:py-0 text-[17px] md:text-[15px] hover:text-black transition-colors"
              >
                {item.label}
              </a>
            </li>
          ))}
          <li className="w-full md:w-auto mt-2 md:mt-0">
            <a
              href="#testar-gratis"
              onClick={(e) => handleSectionClick(e, '#testar-gratis')}
              className="flex items-center justify-center bg-black text-white font-bold no-underline py-[14px] md:py-[10px] px-6 rounded-full text-[15px] md:text-[14px] hover:opacity-80 transition-opacity"
            >
              30 dias grátis →
            </a>
          </li>
        </ul>
      </div>
    </nav>
  )
}
